/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VideoDetailsAnswerUserSpecificInfo
 */
export interface VideoDetailsAnswerUserSpecificInfo {
    /**
     * 
     * @type {string}
     * @memberof VideoDetailsAnswerUserSpecificInfo
     */
    lastCompleted?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoDetailsAnswerUserSpecificInfo
     */
    timesCompleted?: string;
}

export function VideoDetailsAnswerUserSpecificInfoFromJSON(json: any): VideoDetailsAnswerUserSpecificInfo {
    return VideoDetailsAnswerUserSpecificInfoFromJSONTyped(json, false);
}

export function VideoDetailsAnswerUserSpecificInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoDetailsAnswerUserSpecificInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastCompleted': !exists(json, 'last-completed') ? undefined : json['last-completed'],
        'timesCompleted': !exists(json, 'times-completed') ? undefined : json['times-completed'],
    };
}

export function VideoDetailsAnswerUserSpecificInfoToJSON(value?: VideoDetailsAnswerUserSpecificInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'last-completed': value.lastCompleted,
        'times-completed': value.timesCompleted,
    };
}


